import { memo } from "react";
import styled from "styled-components";
import { Switch, Tooltip } from "antd";
import { SyncOutlined } from "@ant-design/icons";

interface AutoRefreshRowProps {
  enabled: boolean;
  onToggle: (checked: boolean) => void;
  intervalSeconds?: number;
  disabled?: boolean;
}

const AutoRefreshRow = ({
  enabled,
  onToggle,
  intervalSeconds = 30,
  disabled = false,
}: AutoRefreshRowProps) => {
  return (
    <Container>
      <Left>
        <SyncOutlined style={{ fontSize: 12, color: "#0369a1" }} />
        <Label>Tự động cập nhật ({intervalSeconds}s):</Label>
      </Left>
      <Tooltip title={disabled ? "Bật hiển thị layer trước" : undefined}>
        <Switch
          checked={enabled}
          onChange={onToggle}
          disabled={disabled}
          size="small"
        />
      </Tooltip>
    </Container>
  );
};

export default memo(AutoRefreshRow);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #f0f9ff;
  border: 1px solid #e0f2fe;
  border-radius: 5px;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Label = styled.span`
  font-size: 12px;
  color: #0369a1;
  font-weight: 500;
`;
